

<input class="numeric-editor" #input type="text" (keydown)="onKeyDown($event)" [(ngModel)]="value" style="width: 100%" autofocus (load)="onLoaded($event)">
